"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ExampleScenario_Operation = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_markdown_1 = require("../Scalar/RTTI_markdown");
var RTTI_ExampleScenario_ContainedInstance_1 = require("./RTTI_ExampleScenario_ContainedInstance");
exports.RTTI_ExampleScenario_Operation = t.recursion('IExampleScenario_Operation', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        number: t.string,
        _number: RTTI_Element_1.RTTI_Element,
        type: t.string,
        _type: RTTI_Element_1.RTTI_Element,
        name: t.string,
        _name: RTTI_Element_1.RTTI_Element,
        initiator: t.string,
        _initiator: RTTI_Element_1.RTTI_Element,
        receiver: t.string,
        _receiver: RTTI_Element_1.RTTI_Element,
        description: RTTI_markdown_1.RTTI_markdown,
        _description: RTTI_Element_1.RTTI_Element,
        initiatorActive: t.boolean,
        _initiatorActive: RTTI_Element_1.RTTI_Element,
        receiverActive: t.boolean,
        _receiverActive: RTTI_Element_1.RTTI_Element,
        request: RTTI_ExampleScenario_ContainedInstance_1.RTTI_ExampleScenario_ContainedInstance,
        response: RTTI_ExampleScenario_ContainedInstance_1.RTTI_ExampleScenario_ContainedInstance
    });
});
//# sourceMappingURL=RTTI_ExampleScenario_Operation.js.map